import { JSONPrimitive } from '@shared/types/utils';

export enum STREAM_METADATA {
  TIMESTAMP = 'timestamp',
  ERROR = 'error',
}

export type MetadataResult = {
  type: STREAM_METADATA;
  payload: any;
};

export const isMetadata = (item: any): item is MetadataResult => {
  return item?.type && item.payload;
};

export type PullResult = any[];

interface BasePushResult {
  __rowIndex: number;
}

export interface InsertResult extends BasePushResult {
  status: 'success' | 'error' | string;
  id?: string;
  timestamp?: string;
}

export type UpdateResult = InsertResult;
export type DeleteResult = InsertResult;

export type PushResult = InsertResult | UpdateResult | DeleteResult;

export type ProviderStreamResult = PullResult | PushResult;

export type ProviderStreamResultWithMetaData<T extends ProviderStreamResult> = T | MetadataResult;

export type InsertRecordError = InsertResult & {
  status: string;
};

export type UpdateRecordError = InsertRecordError;
export type DeleteRecordError = InsertRecordError;

export const isInsertRecordError = (item: any): item is InsertRecordError => {
  return item && typeof item === 'object' && 'status' in item && !['success', 'error'].includes(item.status);
};

export const isUpdateRecordError = isInsertRecordError;
export const isDeleteRecordError = isInsertRecordError;

export type PushObjectRecord = [number, ...JSONPrimitive[]];
